import React, { useEffect } from 'react';
import { X, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/i18n/LanguageContext';
import { track } from '@/lib/analytics';
import AmigosWordmark from './AmigosWordmark';

const LINKS = [
  { to: '/', key: 'home' },
  { to: '/services', key: 'services' },
  { to: '/areas', key: 'areas' },
  { to: '/how-bail-works', key: 'how' },
  { to: '/faq', key: 'faq' },
  { to: '/contact', key: 'contact' },
];

const MobileNavOverlay = ({ open, onClose, phoneDisplay, phoneTel }) => {
  const { t } = useLanguage();

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="mnav-overlay" role="dialog" aria-modal="true" aria-label="Site navigation" data-testid="mobile-nav-overlay">
      <div className="mnav-overlay__top">
        <AmigosWordmark size="sm" subline={null} testId="mobile-nav-wordmark" />
        <button className="mnav-overlay__close" onClick={onClose} aria-label="Close menu" data-testid="mobile-nav-close">
          <X size={22} />
        </button>
      </div>
      <ul className="mnav-overlay__links">
        {LINKS.map((l) => (
          <li key={l.to}>
            <Link to={l.to} onClick={onClose} data-testid={`mnav-link-${l.key}`}>{t(`nav.${l.key}`)}</Link>
          </li>
        ))}
        <li><Link to="/start-a-bond" className="accent" onClick={onClose} data-testid="mnav-link-start-bond">{t('nav.startBond')}</Link></li>
      </ul>
      <div className="mnav-overlay__footer">
        <p className="mnav-overlay__support">{t('utility.trust')} · {t('utility.help247')}</p>
        <a href={`tel:${phoneTel}`} className="btn-brass" style={{ justifyContent: 'center' }} onClick={() => { track('phone_click', { location: 'mobile_nav' }); onClose(); }} data-testid="mnav-call-btn">
          <Phone size={16} /> {phoneDisplay}
        </a>
        <Link to="/start-a-bond" className="btn-red" style={{ justifyContent: 'center' }} onClick={onClose} data-testid="mnav-start-bond-btn">{t('common.startBond')}</Link>
      </div>
    </div>
  );
};

export default MobileNavOverlay;
